import {colors} from './colors';
import {legacy} from './legacy';
import {radii} from './radius';
import {spacing} from './spacing';
import {transition} from './transition';
import {typography} from './typography';
import {zIndices} from './z-index';

export const foundations = {
  zIndices,
  radii,
  legacy,
  colors,
  ...typography,
  spacing,
  transition,
};

export type FoundationsType = typeof foundations;
